import { useMemo } from "react";
import { PlugZap } from "@/components/animate-ui/icons/plug-zap";
import { useIntegrationCatalog } from "@/lib/api/hooks/integrations";

export function IntegrationsScreen() {
	const { data: catalog } = useIntegrationCatalog();

	// Get integrations for display: popular first, then fill with alphabetically sorted others
	const displayIntegrations = useMemo(() => {
		if (!catalog?.length) return [];

		const popular = catalog.filter((i) => i.is_popular);
		if (popular.length >= 6) return popular.slice(0, 6);

		const nonPopular = catalog
			.filter((i) => !i.is_popular)
			.sort((a, b) => a.name.localeCompare(b.name));

		return [...popular, ...nonPopular].slice(0, 6);
	}, [catalog]);

	return (
		<div className="space-y-6">
			{/* Heading */}
			<div className="space-y-3 text-center">
				<h2 className="text-2xl font-semibold tracking-tight">
					Connect your apps for company knowledge and take actions
				</h2>
				<p className="text-base text-muted-foreground">
					Stop interrupting colleagues with questions and automate your work.
				</p>
			</div>

			{/* 3-column grid of popular integrations */}
			<div className="grid grid-cols-3 gap-4">
				{displayIntegrations.map((integration) => (
					<div
						key={integration.id}
						className="flex flex-col items-center gap-2 rounded-lg border bg-card p-4"
					>
						<div className="flex size-12 items-center justify-center">
							{integration.logo_url ? (
								<img
									src={integration.logo_url}
									alt={`${integration.name} logo`}
									className="size-10 object-contain"
								/>
							) : (
								<PlugZap className="size-8 text-muted-foreground" />
							)}
						</div>
					</div>
				))}
			</div>

			{/* "And many more..." subtitle */}
			<p className="text-center text-sm text-muted-foreground">And many more...</p>
		</div>
	);
}
